import { myPageAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';

export default {
  async FETCH_LIST({ getters, commit }) {
    const { totalPage, page } = getters['getPageInfo'];
    const condition = getters['getCondition'];
    if (condition.page > totalPage) return;

    const { status, data } = await ServiceExec.get(
      myPageAPI.coupon_list,
      condition
    );

    if (status === ServiceExec.status.OK) {
      const { pageInfo, list } = data;
      commit('setList', list ?? []);
      commit('setPageInfo', pageInfo);

      commit('setPage', condition.page + 1);
    }
  },

  async fetchTotalCoupon({ commit }, userNo) {
    const { data } = await ServiceExec.get(myPageAPI.coupon_total(userNo));
    commit('setTotalCoupon', data);
    return data;
  }
};
